import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import { ALL_MY_GAMES_BY_ID, GAME_USERS } from "../../GraphQL/Queries";
import { useLazyQuery, useMutation } from "@apollo/client";
import { clientWellness } from "../../App";
import { uploadFile, getFile } from "../../services/FileManager";
import { CREATE_GAME, UPDATE_GAME } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CreateGameComponent from "../../components/CreateGameComponent";
import { GeneralContainer, ContentWrapper } from "./CreateGameContainer.styled";
import ModalLoader from "../../components/ModalLoader/ModalLoader";

const CreateGameContainer = () => {
  const location = useLocation();
  const [countries] = useState([]);
  const [cities] = useState([]);
  const [, setCountryId] = useState();
  const history = useHistory();
  const action = location?.state?.mygame ? "edit" : "add";
  const [files, setFiles] = useState({});
  const [mygame, setMyGame] = useState();
  const [usersAssigned, setUsersAssigned] = useState([]);
  const [createGame] = useMutation(CREATE_GAME, { client: clientWellness });
  const [updateGame] = useMutation(UPDATE_GAME, { client: clientWellness });
  const [loadingCoverImage, setLoadingCoverImage] = useState(false);
  const [fileName, setFileName] = useState();
  const [dataSpace, setDataSpace] = useState();
  const [usersRegistered, setUsersRegistered] = useState();
  const [groupRegistered, setGroupRegistered] = useState();
  const [showLoader, setShowLoader] = useState(false);

  const [runQueryAllMyGamesById, { loading: loadingGamebyID }] = useLazyQuery(
    ALL_MY_GAMES_BY_ID,
    {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.gameById) {
          setMyGame(data?.gameById);
        }
      },
    }
  );

  const [runQueryUsersAssigned, { loading: loadingUsersAssigned }] =
    useLazyQuery(GAME_USERS, {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.usersByGameId) {
          setUsersAssigned(data.usersByGameId);
        }
      },
    });

  useEffect(() => {
    if (location?.state?.mygame) {
      runQueryAllMyGamesById({
        variables: { gameId: location?.state?.mygame?.id },
      });
      runQueryUsersAssigned({
        variables: { gameId: location?.state?.mygame?.id },
      });
    }
  }, [location?.state?.mygame]);

  useEffect(() => {
    if (mygame?.coverImage) {
      setLoadingCoverImage(true);
      getFile(mygame?.coverImage)
        .then((response) => {
          try {
            response.lastModifiedDate = new Date();
            response.name = mygame?.coverImage;
            const myFile = new File([response], mygame?.coverImage, {
              type: response.type,
            });
            setFiles({ file: myFile });
            setLoadingCoverImage(false);
          } catch (error) {
            setLoadingCoverImage(false);

            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setLoadingCoverImage(false);
        });
    }
  }, [mygame]);

  useEffect(() => {
    if (
      (action === "add" && fileName) ||
      (action === "add" && fileName === "")
    ) {
      handleCreateGame();
    }

    if (
      (action === "edit" && fileName) ||
      (action === "edit" && fileName === "")
    ) {
      handleUploadGame();
    }
  }, [fileName, dataSpace]);

  let goToBackPage = () => {
    history.push({ pathname: "/GamesManagement" });
  };

  let handleUploadGame = () => {
    setShowLoader(true);
    if (moment(dataSpace?.finishDate).isAfter(moment(dataSpace?.startDate))) {
      updateGame({
        variables: {
          gameId: mygame?.gameId,
          name: dataSpace?.name,
          description: dataSpace?.description,
          coverImage: fileName ? fileName : "",
          topic: dataSpace?.topic,
          startDate: new Date(dataSpace?.startDate).toUTCString(),
          endDate: new Date(dataSpace?.finishDate).toUTCString(),
          url: dataSpace?.url,
          individualUsers: usersRegistered,
          gameGroups: groupRegistered,
        },
      })
        .then((response) => {
          if (response.data.updateGame.name) {
            NotificationManager.success(
              "The game is successfully updated",
              "",
              5000
            );
            goToBackPage();
          } else NotificationManager.warning("Update game failed", "", 5000);
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    } else {
      NotificationManager.error(
        "End Date must be greater than the Start Date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let handleCreateGame = () => {
    setShowLoader(true);
    if (moment(dataSpace?.finishDate).isAfter(moment(dataSpace?.startDate))) {
      createGame({
        variables: {
          name: dataSpace?.name,
          description: dataSpace?.description,
          coverImage: fileName ? fileName : "",
          topic: dataSpace?.topic,
          startDate: new Date(dataSpace?.startDate).toUTCString(),
          endDate: new Date(dataSpace?.finishDate).toUTCString(),
          url: dataSpace?.url,
          individualUsers: usersRegistered,
          gameGroups: groupRegistered,
        },
      })
        .then((response) => {
          if (response.data.addGame.name) {
            NotificationManager.success(
              "The Game is successfully created",
              "",
              5000
            );
            goToBackPage();
          } else NotificationManager.warning("Create Game failed", "", 5000);
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
          setShowLoader(false);
        });
    } else {
      NotificationManager.error(
        "End Date must be greater than the Start Date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let createNew = (data, groupsSelected, usersSelected, folderName) => {
    setShowLoader(true);
    setUsersRegistered(
      usersSelected.map((item) => {
        if (item.userId) {
          return item.userId;
        }
        if (item.ccmsuser) {
          return item.value;
        }
      })
    );
    setGroupRegistered(
      groupsSelected.map((item) => {
        if (item.isGroup) {
          return {
            userList: [item.userId],
            groupName: item.name,
          };
        } else if (item.userIds) {
          return {
            userList: [...item.userIds],
            groupName: item.groupName,
          };
        }
      })
    );
    if (data && new Date(data.startDate) > new Date()) {
      if (data.file) {
        uploadFile([data.file], folderName)
          .then((imageName) => {
            let arrayNames = JSON.parse(imageName);
            setFileName(arrayNames[0].newName);
            setShowLoader(false);
          })
          .catch((error) => {
            setShowLoader(false);

            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
          });
      } else {
        setShowLoader(false);
        setFileName("");
      }
      setDataSpace(data);
    } else {
      NotificationManager.warning(
        "The date must be greater than the current date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  let updateOld = (data, groupsSelected, usersSelected, folderName) => {
    setShowLoader(true);
    setUsersRegistered(
      usersSelected.map((item) => {
        if (item.userId) {
          return item.userId;
        }
        if (item.ccmsuser) {
          return item.value;
        }
        if (item.value) {
          return item.value;
        }
      })
    );
    setGroupRegistered(
      groupsSelected.map((item) => {
        if (item.isGroup) {
          return {
            userList: [item.userId],
            groupName: item.name,
          };
        } else if (item.userIds) {
          return {
            userList: [...item.userIds],
            groupName: item.groupName,
          };
        }
      })
    );
    if (mygame && data && new Date(data.startDate) > new Date()) {
      if (data?.file?.name?.indexOf("/") === -1) {
        uploadFile([data.file], folderName)
          .then((imageName) => {
            let arrayNames = JSON.parse(imageName);
            setFileName(arrayNames[0].newName);
            setShowLoader(false);
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
            setShowLoader(false);
          });
      } else if (data?.file) {
        if (data.file.name.indexOf("/") !== -1) {
          setFileName(data.file.name);
        }
        setShowLoader(false);
      } else {
        setShowLoader(false);
        setFileName("");
      }
      setDataSpace(data);
    } else {
      NotificationManager.warning(
        "The date must be greater than the current date",
        "",
        5000
      );
      setShowLoader(false);
    }
  };

  return (
    <GeneralContainer>
      <div style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
        <BackButtonComponent
          backtitle={"Game Management"}
          locationtitle={action === "add" ? "New Game" : mygame?.name}
          goToBackPage={goToBackPage}
          identity={"createGame"}
        />
      </div>
      <hr style={{ marginLeft: "1.5rem", width: "96.5%" }} />
      <ContentWrapper>
        <CreateGameComponent
          files={files}
          setFiles={setFiles}
          loadingCoverImage={loadingCoverImage}
          SpaceEdit={mygame}
          usersAssigned={usersAssigned}
          createNew={createNew}
          updateOld={updateOld}
          action={action}
          goToBackPage={goToBackPage}
          setCountryId={setCountryId}
          countries={countries}
          cities={cities}
        />
      </ContentWrapper>
      {(loadingGamebyID || loadingUsersAssigned || showLoader) && (
        <ModalLoader />
      )}
    </GeneralContainer>
  );
};

export default CreateGameContainer;
